// Optional component-injection context for Livemark.
//
// Shared markdown wrappers always render through Livemark directly. Ask uses
// this context to supply app-specific component hooks such as action buttons,
// entity chips, and table actions without coupling the shared Livemark
// implementation to app code.
import { createContext, useContext, useEffect } from 'react';
export const LivemarkComponentsContext = createContext({
    components: null,
});
LivemarkComponentsContext.displayName = 'LivemarkComponentsContext';
export function useLivemarkComponents() {
    const { components, loadComponents } = useContext(LivemarkComponentsContext);
    useEffect(() => {
        if (!components) {
            loadComponents?.();
        }
    }, [components, loadComponents]);
    return components;
}
//# sourceMappingURL=LivemarkComponentsContext.js.map